import * as msal from '@azure/msal-browser'

const { host, protocol, pathname } = window.location

const msalConfig = {
  auth: {
    // 'Application (client) ID' of app registration in Azure portal - this value is a GUID
    clientId: process.env.VUE_APP_AZURE_AUTH_CLIENT_ID,
    // Full directory URL, in the form of https://login.microsoftonline.com/<tenant-id>
    authority: process.env.VUE_APP_AZURE_AUTH_AUTHORITY,
    // Full redirect URL, in form of http://localhost:3000
    redirectUri: host.split('.').length > 2
      ? `${protocol}//${host.split('.')[1]}.com${pathname}`
      : `${protocol}//${host}${pathname}`
  },
  cache: {
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
}

export const MSAL = new msal.PublicClientApplication(msalConfig)
